/**
 * WordPress dependencies
 */
import { AlignmentToolbar } from '@wordpress/block-editor';
import { addFilter } from '@wordpress/hooks';
import { Fragment } from '@wordpress/element';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-block-controls`,
	`Gutenify/Block/${ hookPrefix }/block-controls/Alignment`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { textAlignment } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<AlignmentToolbar
					value={ textAlignment }
					onChange={ ( align ) => {
						setAttributes( { textAlignment: align } );
					} }
				/>
			</Fragment>,
		];
	}
);

